/* unplugin-vue-components disabled */import script from "./User.vue?vue&type=script&setup=true&lang=tsx"
export * from "./User.vue?vue&type=script&setup=true&lang=tsx"

import "./User.vue?vue&type=style&index=0&id=9eeeb378&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9eeeb378"]])

export default __exports__